import { createSlice } from '@reduxjs/toolkit';

import { SENTRY } from '@modules/_misc';
import { setTimezoneDiff } from '@modules/date';
import { combine_majors } from '@modules/programs';
import { DEFAULT_STATE, GET_STORE, check_loading_fields } from '@modules/redux';

const initialState = GET_STORE.global(),
	finish_loading_data = (_state, key) => {
		let i = _state.loading_data.indexOf(key);
		if (i > -1) _state.loading_data.splice(i, 1);
	},
	globalSlice = createSlice({
		name: 'global',
		initialState,
		reducers: {
			setCurrentPage(state, action) {
				let { payload: val } = action;

				if (state.current_page) {
					state.prev_page = `${state.current_page}`;
					SENTRY.set_tag('previous_page', state.prev_page);
				}

				state.current_page = val;
				state.loading_data = check_loading_fields(state);
			},
			captureError(state, action) {
				let { payload: ex } = action;

				if (ex) {
					state.ex = typeof ex === 'string' ? new Error(ex) : ex;
				} else {
					state.ex = null;
				}
			},
			onGetTimezoneDiff(state, action) {
				let { payload: val } = action;

				state.timezone_diff = val;
				setTimezoneDiff(val);
				finish_loading_data(state, 'timezone_diff');
			},
			onCheckForStaleData(state, action) {
				let { payload: current_page } = action,
					{ date_cached } = state,
					d = new Date(date_cached),
					d_login = new Date(),
					date_string = str => `${str.getMonth()}-${str.getDate()}-${str.getFullYear()}`;

				if (date_string(d) !== date_string(d_login)) {
					const { timezone_diff, current_page: prev_current_page } = state;

					Object.keys(DEFAULT_STATE.global).forEach(key => (state[key] = DEFAULT_STATE.global[key]));

					state.date_cached = new Date().toString();
					state.timezone_diff = timezone_diff;
					state.current_page = current_page || '';
					state.prev_page = prev_current_page;

					localStorage.removeItem('global');
					SENTRY.set_tag('previous_page', state.prev_page);
				}
			},
			onGetData(state, action) {
				let { str_prop, arr } = action.payload;

				// tms: system_notifications might legitimately be an empty array
				if (Array.isArray(arr) && (!!arr.length || str_prop === 'system_notifications')) {
					state[str_prop] = arr || [];
					finish_loading_data(state, str_prop);
				}
			},
			onGetTerms(state, action) {
				let { key, arr } = action.payload;

				if (Array.isArray(arr)) state.terms[key] = arr || [];

				const done_loading_terms = Object.keys(state.terms).every(key => !!state.terms[key].length);
				if (done_loading_terms) finish_loading_data(state, 'terms');
			},
			onGetMajors(state, action) {
				let { majors, sub_majors } = action.payload,
					submajor_key = rec =>
						`${rec.field_campus_id}|${rec.title}|${rec.field_academic_level}|${rec.field_cmc_program_type}|${rec.field_parent_program_id}`,
					unique_submajors = sub_majors.filter(
						(x, i) => sub_majors.findIndex(y => submajor_key(y) === submajor_key(x)) === i
					);

				state.cdrMajors = combine_majors(majors, unique_submajors);
				finish_loading_data(state, 'cdrMajors');
			},
			onGetEssayPrompts(state, action) {
				let { key, arr } = action.payload;

				if (Array.isArray(arr)) state.essay_prompts[key] = arr || [];

				if (!!state.essay_prompts.global.length && !!state.essay_prompts.campus_specific.length) {
					finish_loading_data(state, 'essay_prompts');
				}
			},
			onGetPaperAppUrl(state, action) {
				let { payload: str } = action;

				state.paper_application_url = str;
				finish_loading_data(state, 'paper_application_url');
			}
		}
	});

export const { actions: globalActions, reducer: globalReducer } = globalSlice;
